var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col" }, [
    _c(
      "div",
      { staticClass: "flex items-start", class: _vm.fieldWrapperClass },
      [
        _c("review-type-dropdown-field", {
          class: _vm.fieldClass,
          attrs: {
            placeholder: "Select Review Type",
            "error-text":
              _vm.validations !== null ? _vm.validations.reviewTypeId : "",
            disabled: _vm.disabled || _vm.disableReviewType,
            inline: _vm.inline,
            indent: _vm.indent,
            clearable: _vm.clearable || _vm.clearableReviewType,
            "only-import-process": _vm.onlyImportProcess,
            "is-exception": _vm.isException,
            label: _vm.reviewTypeLabel,
          },
          on: {
            "import-process-id": function ($event) {
              return _vm.$emit("import-process-id", $event)
            },
            "review-type": function ($event) {
              return _vm.setReviewType($event)
            },
            source: function ($event) {
              _vm.reviewTypeSource = $event
            },
          },
          model: {
            value: _vm.model.reviewTypeId,
            callback: function ($$v) {
              _vm.$set(_vm.model, "reviewTypeId", $$v)
            },
            expression: "model.reviewTypeId",
          },
        }),
        _vm._v(" "),
        _vm.addReviewType
          ? _c(
              "action",
              {
                staticClass: "pl-2 pt-1",
                class: _vm.actionClass,
                attrs: { icon: "mdi mdi-plus-circle-outline pr-2" },
                on: {
                  click: function ($event) {
                    return _vm.openAddReviewTypeModal()
                  },
                },
              },
              [_vm._v("Type")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex items-start", class: _vm.fieldWrapperClass },
      [
        _c("review-vendor-dropdown-field", {
          class: _vm.fieldClass,
          attrs: {
            label: _vm.reviewVendorLabel,
            placeholder: `Select ${_vm.vendorName}`,
            "review-id": _vm.model.reviewTypeId,
            disabled:
              _vm.disabled || _vm.disableReviewVendor || _vm.disableVendor,
            "error-text":
              _vm.validations !== null ? _vm.validations.vendorId : "",
            inline: _vm.inline,
            indent: _vm.indent,
            clearable: _vm.clearable || _vm.clearableReviewVendor,
          },
          on: {
            "review-vendor": function ($event) {
              return _vm.$emit("review-vendor", $event)
            },
            source: function ($event) {
              _vm.vendorSource = $event
            },
          },
          model: {
            value: _vm.model.vendorId,
            callback: function ($$v) {
              _vm.$set(_vm.model, "vendorId", $$v)
            },
            expression: "model.vendorId",
          },
        }),
        _vm._v(" "),
        _vm.addReviewTypeVendor
          ? _c(
              "action",
              {
                staticClass: "pl-2 pt-1",
                class: _vm.actionClass,
                attrs: {
                  icon: "mdi mdi-plus-circle-outline pr-2",
                  disabled: _vm.disableVendor,
                },
                on: {
                  click: function ($event) {
                    return _vm.openAddReviewTypeVendorModal()
                  },
                },
              },
              [_vm._v("Vendor")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex items-start", class: _vm.fieldWrapperClass },
      [
        _c("review-product-dropdown-field", {
          class: _vm.fieldClass,
          attrs: {
            placeholder: "Select Product",
            "review-id": _vm.model.reviewTypeId,
            "vendor-id": _vm.model.vendorId,
            disabled:
              _vm.disabled || _vm.disableReviewProduct || _vm.disableProduct,
            "error-text":
              _vm.validations !== null ? _vm.validations.productId : "",
            inline: _vm.inline,
            indent: _vm.indent,
            clearable: _vm.clearable || _vm.clearableReviewProduct,
            label: _vm.reviewProductLabel,
          },
          on: {
            "review-product": function ($event) {
              return _vm.$emit("review-product", $event)
            },
            source: function ($event) {
              _vm.productSource = $event
            },
          },
          model: {
            value: _vm.model.productId,
            callback: function ($$v) {
              _vm.$set(_vm.model, "productId", $$v)
            },
            expression: "model.productId",
          },
        }),
        _vm._v(" "),
        _vm.addReviewProduct
          ? _c(
              "action",
              {
                staticClass: "pl-2 pt-1",
                class: _vm.actionClass,
                attrs: {
                  icon: "mdi mdi-plus-circle-outline pr-2",
                  disabled: _vm.disableProduct,
                },
                on: {
                  click: function ($event) {
                    return _vm.openAddReviewProductModal()
                  },
                },
              },
              [_vm._v("Product")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }